module.exports = __webpack_public_path__ + "static/media/bg-firework.1a5384a6.png";